import { render } from "./DeployVnfAppliance.vue?vue&type=template&id=21fce6e8&scoped=true"
import script from "./DeployVnfAppliance.vue?vue&type=script&lang=js"
export * from "./DeployVnfAppliance.vue?vue&type=script&lang=js"

import "./DeployVnfAppliance.vue?vue&type=style&index=0&id=21fce6e8&lang=less&scoped=true"
import "./DeployVnfAppliance.vue?vue&type=style&index=1&id=21fce6e8&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fce6e8"]])

export default __exports__